import { reactive } from 'vue';
import useClientDataSetRepository from '@/modules/billingSet/repositories/clientdataset.repository.js';
import store from '@/store/index';
import useJob from '@/modules/shared/composables/job.composable.js';

export default function useClientDataSet(billingSetId) {
  const clientDataSetRepository = useClientDataSetRepository(billingSetId);
  const statusSummaryList = reactive({ loadingCompleted: false, data: null, jobIsRunning: false });
  const { startFastJobPolling } = useJob();

  const loadStatusSummary = () => {
    statusSummaryList.loadingCompleted = false;

    clientDataSetRepository.loadStatusSummary()
      .then((response) => {
        statusSummaryList.loadingCompleted = true;
        statusSummaryList.data = response.data;
        if (response.data.jobIsRunning) {
          // eslint-disable-next-line no-use-before-define
          startClientDataPolling();
        }
      });
  };

  const loadStatusSummaryWithoutAnimation = () => {
    clientDataSetRepository.loadStatusSummary()
      .then((response) => {
        statusSummaryList.data = response.data;
      });
  };

  const fastPollingIntervalInMS = 3000;
  let fastPollingId;

  // Poll every 3 second
  const startClientDataPolling = () => {
    // eslint-disable-next-line no-use-before-define
    stopClientDataPolling();
    fastPollingId = setInterval(() => {
      loadStatusSummaryWithoutAnimation();
    }, fastPollingIntervalInMS);
  };

  const stopClientDataPolling = () => {
    if (fastPollingId != null) {
      clearInterval(fastPollingId);
      fastPollingId = null;
    }
  };

  const createClientDataSets = () => {
    clientDataSetRepository.create()
      .then((response) => {
        if (response.data.success) {
          statusSummaryList.jobIsRunning = true;

          // Start polling JobList at a fast pace
          startFastJobPolling();
          startClientDataPolling();

          store.dispatch('addSuccessNotification', 'Manglende PI-datasæt bliver nu oprettet.');
        } else {
          if (response.data.messages.length > 0) {
            store.dispatch('addNotifications', { messageList: response.data.messages });
          }
          stopClientDataPolling();
        }
      });
  };

  return {
    loadStatusSummary,
    statusSummaryList,
    createClientDataSets,
    startClientDataPolling,
    stopClientDataPolling,
  };
}
